import { render, staticRenderFns } from "./TotalValueThis.vue?vue&type=template&id=b41c54cc"
import script from "./TotalValueThis.vue?vue&type=script&lang=js"
export * from "./TotalValueThis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports